import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DeliveryChargeItem {
  id: number;
  slotid: number;
  charge_type: string;
  min_amount: number;
  max_amount: number;
  charge_value: number;
  status?: string;
  createdon?: string;
  updatedon?: string | null;
  updatedby?: string | null;
  createdby?: string | null;
  slotcode?: string;
  slotname?: string;
}

interface DoorstepRequestItem {
  requestid: number;
  delivstatus: string;
  [key: string]: any; // keep flexible to match backend payload
}

interface DeliveryChargeState {
  charges: DeliveryChargeItem[];
  deliveryRequests: DoorstepRequestItem[];
  deliveryRequestsPagination: {
    page?: number;
    per_page?: number;
    total_pages?: number;
    total_items?: number;
    [key: string]: any;
  } | null;
  successMsg: { message: string; id: string | number };
  errorMsg: { message: string; id: string | number };
  loading: boolean;
  lastCreatedChargeId: number | null;
}

export const initialState: DeliveryChargeState = {
  charges: [],
  deliveryRequests: [],
  deliveryRequestsPagination: null,
  successMsg: { message: "", id: "" },
  errorMsg: { message: "", id: "" },
  loading: false,
  lastCreatedChargeId: null,
};

const deliveryChargeSlice = createSlice({
  name: "deliverycharge",
  initialState,
  reducers: {
    setCharges(state, action: PayloadAction<DeliveryChargeItem[]>) {
      state.charges = action.payload || [];
    },

    setDeliveryRequests(state, action: PayloadAction<DoorstepRequestItem[]>) {
      state.deliveryRequests = action.payload || [];
    },

    setDeliveryRequestsPagination(
      state,
      action: PayloadAction<DeliveryChargeState["deliveryRequestsPagination"]>
    ) {
      state.deliveryRequestsPagination = action.payload ?? null;
    },

    deliveryChargeSuccess(state, action) {
      state.successMsg = action.payload;
    },

    deliveryChargeError(state, action) {
      state.errorMsg = action.payload;
    },

    setDeliveryChargeLoader(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setLastCreatedChargeId(state, action: PayloadAction<number | null>) {
      state.lastCreatedChargeId = action.payload ?? null;
    },
  },
});

export const {
  setCharges,
  setDeliveryRequests,
  setDeliveryRequestsPagination,
  deliveryChargeSuccess,
  deliveryChargeError,
  setDeliveryChargeLoader,
  setLastCreatedChargeId,
} = deliveryChargeSlice.actions;

export default deliveryChargeSlice.reducer;

